import React, { Component } from 'react';
import styles from './style.css';

class Adcorner extends Component {
    constructor() {
        super();
        this.state = {
            isRender: true,
            conerHide: true,
        };
    }
    componentDidMount() {
        this.refs['connerClose'].addEventListener('click', () => {
            this.cornerClose();
        });
    }
    hide() {
        this.setState({
            showItem: false,
        });
    }
    show() {
        this.setState({
            showItem: true,
        });
    }
    // 点击关闭corner广告
    cornerClose() {
        this.setState({
            conerHide: true,
            showItem: false,
        });
    }
    // 显示corner广告
    cornerShow() {
        this.setState({
            showItem: true,
            conerHide: false,
        });
    }
    destory() {
        this.setState({
            isRender: false,
        });
    }
    render() {
        const { isRender, showItem, conerHide } = this.state;
        const children = isRender ? (
            <div
                style={{ display: showItem ? 'block' : 'none' }}
                className={conerHide ? styles.connerAdHide : styles.connerAd}
                ref={c => {
                    this.el = c;
                }}
                id="js_conner_ad">
                <i className={styles.connerClose} ref="connerClose" id="js_conner_close" />
            </div>
        ) : null;

        return children;
    }
}

export default Adcorner;
